module.exports = __webpack_public_path__ + "static/search-f6c7c392981d1d0d5dda683942153e54.mp4";